/**
 * Yarn Park free-shipping bar (2026-10-02).
 *
 * The theme compared the number 75 with the cart total in the shopper's own currency. The real rule is the automatic
 * discount "FREE SHIPPING on Orders Over €75", which only applies when the shipping rate is under €22.
 * This script converts the threshold with Shopify's own checkout rate (Shopify.currency.rate), rounds it up to a whole
 * unit so the bar never promises too early, and hides the bar in countries whose shipping rate is €22 or more.
 *
 * It also rewrites the euro amounts in the announcement bar into the shopper's currency (rounded up), and drops the
 * free-shipping part of the announcement in countries that can't get it.
 *
 * Australia and New Zealand are not in the €75 discount (removed 2026-10-02); their shipping zone has its own free rate
 * from AUD 150, set in COUNTRY_THRESHOLDS.
 *
 * The cart total comes from the page itself (data snippet on load, and a data-yp-cart-total attribute that the theme
 * re-renders inside the cart drawer after every change), so quantity clicks need no extra request and the bar never
 * blinks. /cart.js is only fetched as a fallback.
 *
 * Keep ELIGIBLE_COUNTRIES in sync with the countries in the €75 discount whose shipping rate is under €22.
 */
(function () {
  var ELIGIBLE_COUNTRIES = [
    // EU1 (€9.90)
    'AT', 'BE', 'FR', 'DE', 'VA', 'IE', 'IT', 'LI', 'LU', 'MC', 'NL', 'ES', 'CH',
    // EU2 (€13.90)
    'CY', 'GE', 'AD', 'CZ', 'DK', 'EE', 'FI', 'HU', 'LV', 'LT', 'MT', 'NO', 'PL', 'PT', 'SM', 'SK', 'SE', 'AL', 'BA',
    'HR', 'FO', 'GI', 'IS', 'XK', 'MD', 'ME', 'MK', 'RS', 'BG', 'GR', 'RO', 'SI', 'UA',
    // United Kingdom (£8.90), USCAMX ($9.90)
    'GB', 'US', 'CA', 'MX',
    // JOQASAAE and BHEGKWLBOM (€9.90)
    'JO', 'QA', 'SA', 'AE', 'BH', 'EG', 'KW', 'LB', 'OM'
  ];

  // Countries with their own free-shipping rate in the shipping zone, in that rate's currency.
  // The bar and banner show this only when the shopper browses in the same currency, and hide it otherwise.
  var COUNTRY_THRESHOLDS = {
    AU: { currency: 'AUD', cents: 15000 },
    NZ: { currency: 'AUD', cents: 15000 }
  };

  // Returns the free-shipping threshold in the shopper's currency (cents), or null when the bar should be hidden.
  function thresholdFor(country, currency, rate, baseCents) {
    var own = COUNTRY_THRESHOLDS[country];

    if (own) {
      return own.currency === currency ? own.cents : null;
    }

    if (ELIGIBLE_COUNTRIES.indexOf(country) === -1 || !(rate > 0)) {
      return null;
    }

    return Math.ceil((baseCents * rate) / 100) * 100;
  }

  // Country names that read better with "the" in front ("Free shipping to the United States").
  var NAMES_WITH_THE = ['US', 'GB', 'NL', 'AE', 'VA'];

  function countryName(code) {
    var name = null;

    try {
      name = new Intl.DisplayNames([document.documentElement.lang || 'en'], { type: 'region' }).of(code);
    } catch (error) {
      return null;
    }

    if (!name || name === code) {
      return null;
    }

    return NAMES_WITH_THE.indexOf(code) !== -1 ? 'the ' + name : name;
  }

  // Replaces "eligible destinations" with the shopper's country, when it is known.
  function localize(text, code) {
    var name = code ? countryName(code) : null;
    return name ? text.replace(/eligible destinations/gi, name) : text;
  }

  var TARGETS = [
    '#mini-cart .mini-cart__alert-wrapper > .alert',
    '#mini-cart .mini-cart__content--empty > .alert',
    '[data-section-type="cart"] .page__header > .page__description',
    '[data-section-type="cart"] .empty-state__description'
  ].join(',');

  var BANNER = '.announcement-bar__content';

  var TOTAL_SOURCE = '#mini-cart [data-yp-cart-total]';

  var cartTotal = null;

  function readData() {
    var element = document.getElementById('yp-fs-data');

    if (!element) {
      return null;
    }

    try {
      return JSON.parse(element.textContent);
    } catch (error) {
      return null;
    }
  }

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  function apply() {
    var elements = document.querySelectorAll(TARGETS);

    if (!elements.length) {
      return;
    }

    var data = readData();
    var shopify = window.Shopify || {};
    var rate = shopify.currency ? parseFloat(shopify.currency.rate) : NaN;
    var currency = shopify.currency ? shopify.currency.active : null;
    var thresholdCents = data ? thresholdFor(shopify.country, currency, rate, data.baseCents) : null;
    var ready = data && data.enabled && currency && thresholdCents !== null && cartTotal !== null;

    Array.prototype.forEach.call(elements, function (element) {
      element.setAttribute('data-yp-fs', '');

      if (!ready) {
        // Hide rather than risk a wrong promise. Elements stay hidden until the cart total is known.
        element.style.display = 'none';
        return;
      }

      var html;

      if (cartTotal >= thresholdCents) {
        html = data.unlocked;
      } else {
        html = data.remaining.replace('%YP_AMOUNT%', '<span>' + formatMoney(thresholdCents - cartTotal, currency) + '</span>');
      }

      html = localize(html, shopify.country);

      if (element.innerHTML !== html) {
        element.innerHTML = html;
      }

      element.style.display = '';
    });
  }

  function formatWhole(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: currency, minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(cents / 100);
    } catch (error) {
      return Math.round(cents / 100) + ' ' + currency;
    }
  }

  function applyBanner() {
    var element = document.querySelector(BANNER);

    if (!element || element.hasAttribute('data-yp-fs')) {
      return;
    }

    var shopify = window.Shopify || {};
    var rate = shopify.currency ? parseFloat(shopify.currency.rate) : NaN;
    var currency = shopify.currency ? shopify.currency.active : null;
    var own = COUNTRY_THRESHOLDS[shopify.country];
    var eligible = ELIGIBLE_COUNTRIES.indexOf(shopify.country) !== -1 || (own && own.currency === currency);
    var text = element.textContent;

    // Countries with their own free rate: show that amount in the free-shipping part.
    if (own && own.currency === currency) {
      text = text.split('·').map(function (part) {
        return /free shipping/i.test(part) ? part.replace(/€\s?\d+(?:[.,]\d+)?/, formatWhole(own.cents, currency)) : part;
      }).join('·');
    }

    // Drop the free-shipping part where the discount can't apply (shipping rate of €22 or more).
    if (!eligible && shopify.country) {
      text = text.split('·').filter(function (part) {
        return !/free shipping/i.test(part);
      }).join('·').trim();

      // The truck emoji goes with the free-shipping part; make sure no separator is left at the start.
      text = text.replace(/^[·\s]+/, '');
    }

    // Convert "€75" style amounts, rounded up so the banner never promises less than checkout requires.
    if (currency && currency !== 'EUR' && rate > 0) {
      text = text.replace(/€\s?(\d+(?:[.,]\d+)?)/g, function (match, amount) {
        var cents = Math.ceil(parseFloat(amount.replace(',', '.')) * rate) * 100;
        return formatWhole(cents, currency);
      });
    }

    if (eligible) {
      text = localize(text, shopify.country);
    }

    if (element.textContent !== text) {
      element.textContent = text;
    }

    element.setAttribute('data-yp-fs', '');
  }

  // Reads the cart total that the theme rendered into the drawer (fresh after every re-render).
  function renderedTotal() {
    var element = document.querySelector(TOTAL_SOURCE);
    var value = element ? parseInt(element.getAttribute('data-yp-cart-total'), 10) : NaN;
    return isNaN(value) ? null : value;
  }

  // Fallback when the page has no rendered total (e.g. the cart page section was re-rendered without a reload).
  function fetchTotal() {
    var root = (window.routes && window.routes.rootUrlWithoutSlash) || '';

    fetch(root + '/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        cartTotal = cart.total_price;
        apply();
      })
      .catch(function () {
        cartTotal = null;
        apply();
      });
  }

  function update(allowFetch) {
    var total = renderedTotal();

    if (total !== null) {
      cartTotal = total;
      apply();
    } else if (allowFetch) {
      fetchTotal();
    } else {
      apply();
    }
  }

  var CART_AREAS = '#mini-cart, [data-section-type="cart"]';

  function isRelevantMutation(record) {
    var target = record.target;

    if (!target || target.nodeType !== 1 || !target.closest) {
      return false;
    }

    // Ignore our own text updates.
    if (target.closest('[data-yp-fs]')) {
      return false;
    }

    if (target.closest(CART_AREAS)) {
      return true;
    }

    // The whole drawer or cart section may be swapped in.
    return Array.prototype.some.call(record.addedNodes, function (node) {
      return node.nodeType === 1 && (node.matches(CART_AREAS) || node.querySelector(CART_AREAS));
    });
  }

  function init() {
    var data = readData();

    applyBanner();

    if (data && typeof data.cartTotal === 'number') {
      cartTotal = data.cartTotal;
    }

    update(cartTotal === null);

    // The theme re-renders the cart drawer and cart page after every change. Mutation callbacks run before the
    // browser paints, so the new message is corrected in the same frame it appears.
    new MutationObserver(function (records) {
      if (records.some(isRelevantMutation)) {
        update(renderedTotal() === null);
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
